export const paymentPageDeprecatedPaths = ['/payment', '/:lang/payment']
export { PaymentPageDeprecationMessage } from './deprecation_message'
